import {
  PerformanceReturnService,
  PerformanceReturnOptions,
  PostPerformanceSummaryOptions,
  PostPerformanceCalculationOptions,
  GetPerformanceReportOptions,
  PostPerformanceSummaryResponse,
  PostTimeBasedCalculationsResponse,
  GetPerformanceReportResponse,
} from '@digital-advice/ms-performance-return-sdk';
import {apiKey, getLogger, endpoint, interceptors, sourceInfo} from '@advisor/services/sdk';

export const defaultOptions: PerformanceReturnOptions = {
  logger: getLogger(),
  apiKey,
  endpoint,
  interceptors,
  sourceInfo,
};

export default class PerformanceReturnServices {
  static async sdkService(options: PerformanceReturnOptions = defaultOptions): Promise<PerformanceReturnService> {
    const service = await new PerformanceReturnService(options);

    return service;
  }

  /**
   * Gateway endpoint: postPerformanceSummary
   */

  static async postPerformanceSummary(payload: PostPerformanceSummaryOptions): Promise<PostPerformanceSummaryResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.postPerformanceSummary(payload);
  }

  /**
   * Gateway endpoint: postTimebasedCalendarYearPerformance
   */

  static async postTimebasedCalendarYearPerformance(
    payload: PostPerformanceCalculationOptions
  ): Promise<PostTimeBasedCalculationsResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.postTimebasedCalendarYearPerformance(payload);
  }

  /**
   * Gateway endpoint: postTimebasedCalendarYearPerformance
   */

  static async postTimebasedTrailingYearPerformance(
    payload: PostPerformanceCalculationOptions
  ): Promise<PostTimeBasedCalculationsResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.postTimebasedTrailingYearPerformance(payload);
  }

  /**
   * Gateway endpoint: postTimebasedCalendarYearPerformance
   */

  static async getPerformanceTrendsByClientId(payload: GetPerformanceReportOptions): Promise<GetPerformanceReportResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.getPerformanceTrendsByClientId(payload);
  }
}
